import { toQueryString } from '@tuic/lib/src/helpers/to-query-string';
import type { VideoResolver, PosterResolver } from '../types';

export const resolveYoutubeVideo: VideoResolver = ({ src, ...attrs }) => {
  if (typeof src === 'undefined') {
    return undefined;
  }

  let videoId = getVideoId(String(src));

  if (typeof videoId === 'undefined') {
    return undefined;
  }

  let params = {
    rel: '0',
    showinfo: '0',
    modestbranding: '1',
    controls: attrs.controls === false ? '0' : '1',
    loop: attrs.loop ? '1' : '0',
    playsinline: attrs.playsInline ? '1' : '0',
    mute: attrs.muted ? '1' : '0',
    enablejsapi: '1',
  };

  return {
    iframe: {
      src: `https://www.youtube.com/embed/${videoId}?${toQueryString(params)}`,
    },
    consentRequired: true,
  };
};

export const resolveYoutubePoster: PosterResolver = ({ src }) => {
  if (typeof src === 'undefined') {
    return undefined;
  }

  let id = getVideoId(String(src));

  if (typeof id === 'undefined') {
    return undefined;
  }

  return {
    src: `https://i1.ytimg.com/vi/${id}/maxresdefault.jpg`,
  };
};

const getVideoId = (src: string): string | undefined => {
  let pattern =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

  let id = src.match(pattern)?.[1] ?? '';

  return id !== '' ? id : undefined;
};
